export default {
  LeftMenu: {
    Control: 'Control',
    CollapseText: 'Thu gọn',
    Dashboard: 'Tổng quan',
    Etreasury: 'Kho bạc điện tử',
    BudgetPlan: 'Dự toán ngân sách',
    CA: 'Tiền mặt',
    BA: 'Tiền gửi',
    Invoice: 'Hoá đơn mua hàng',
    Receipt: 'Biên lai',
    SU: 'Vật tư, công cụ dụng cụ',
    FA: 'Tài sản cố định',
    Salary: 'Lương',
    GL: 'Tổng hợp',
    Report: 'Báo cáo',
    QuickReport: 'Báo cáo nhanh',
    AccountBlance: 'Nhập số dư đầu kỳ',
    Dictionary: 'Danh mục',
    ConnectExperts: 'Kế toán dịch vụ',
    ExaminationResults: 'Kết quả kiểm tra',
    SettlementInstructions: 'Hướng dẫn quyết toán',
    UsefulKnowledge: 'Kiến thức hữu ích',
  },
  Nav: {
    PostedDate: 'Ngày hạch toán:',
    Search: 'Tìm chứng từ',
  },
};
